import React from 'react';
import SensitiveValue from './SensitiveValue';

interface PlatformData {
  platform_id: number;
  platform_name: string;
  total_value_eur: number;
  percentage: number;
  areas: Array<{
    name: string;
    value_eur: number;
    percentage: number;
  }>;
}

interface PlatformCardsProps {
  data: PlatformData[];
}

const PlatformCards: React.FC<PlatformCardsProps> = ({ data }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      {data.map((platform) => (
        <div key={platform.platform_id} className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-800">{platform.platform_name}</h3>
              <p className="text-2xl font-bold text-blue-600">
                <SensitiveValue>
                  €{platform.total_value_eur.toFixed(2)}
                </SensitiveValue>
              </p>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-500">Percentagem</div>
              <div className="text-lg font-semibold text-gray-700">
                {platform.percentage.toFixed(1)}%
              </div>
            </div>
          </div>
          
          {/* Mostrar moeda original se não for EUR */}
          {platform.areas.some(area => area.name.includes('USDT') || area.name.includes('Copy Traders') || area.name.includes('Wealth')) && (
            <div className="mt-2 text-sm text-gray-600">
              <span className="font-medium">
                <SensitiveValue>
                  {(platform.total_value_eur / 0.85).toFixed(2)} USDT
                </SensitiveValue>
              </span>
              <span className="ml-1 text-xs">
                (≈<SensitiveValue>€{platform.total_value_eur.toFixed(2)}</SensitiveValue>)
              </span>
            </div>
          )}
          
          {/* Lista de áreas */}
          <div className="mt-3">
            <div className="text-xs text-gray-500 mb-1">Áreas:</div>
            <div className="space-y-1">
              {platform.areas.map((area, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span className="text-gray-700">{area.name}</span>
                  <span className="text-gray-600">
                    <SensitiveValue>
                      €{area.value_eur.toFixed(2)}
                    </SensitiveValue>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlatformCards;
